import { render, staticRenderFns } from "./DeliveryAddressListItem.vue?vue&type=template&id=d0f536ba&scoped=true&"
import script from "./DeliveryAddressListItem.vue?vue&type=script&lang=js&"
export * from "./DeliveryAddressListItem.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryAddressListItem.vue?vue&type=style&index=0&id=d0f536ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f536ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VScrollXTransition } from 'vuetify/lib/components/transitions';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VListItem,VListItemAction,VScrollXTransition,VTooltip})
